const cartitems = (state) => {
    return state.cartitems
}

const cartproduct = (state) => (product_id) => {
    let product = state.cartitems.filter(function (item) {
        return (item.product_id === product_id)
    });

    if(typeof product[0] != 'undefined') {
        // подсчет суммы всех вариантов товара
        return  product.reduce(function(sum, current) {
            return sum + current.qty;
        }, 0);
    }
    return 0;
}
const cartcount = (state) => {
    return state.cartcount
}
const cartsumm = (state) => {
    return state.cartsumm
}
const change_cart = (state) => {
    return state.change_cart
}
const pc_discount = (state) => {
    return state.pc_discount
}
const pc_code = (state) => {
    return state.pc_code
}

export default {
    cartitems,
    cartproduct,
    cartcount,
    cartsumm,
    change_cart,
    pc_discount,
    pc_code
}
